import {
  createLoader,
  inferParserType,
  parseAsArrayOf,
  parseAsBoolean,
  parseAsString,
  parseAsStringEnum,
} from 'nuqs'

export const CharacterSearchSearchParams = {
  keyword: parseAsString.withDefault(''),
  keywords: parseAsArrayOf(parseAsString).withDefault([]),
  sorting: parseAsStringEnum([
    'latest',
    'hot',
    'view-count',
    'rising',
    'verified',
  ]).withDefault('hot'),
  sortForDate: parseAsStringEnum(['week', 'month', 'year']),
  isVerified: parseAsStringEnum(['y', 'n']).withDefault('n'),

  categories: parseAsArrayOf(parseAsString).withDefault([]),
  genres: parseAsArrayOf(parseAsString).withDefault([]),
  color: parseAsString.withDefault(''),
  countryCode: parseAsArrayOf(parseAsString).withDefault([]),

  typesense: parseAsBoolean.withDefault(false),
}

export const loadCharacterSearchSearchParams = createLoader(
  CharacterSearchSearchParams,
)

export type CharacterSearchSearchParams = inferParserType<
  typeof CharacterSearchSearchParams
>
